import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FaqCategories, FaqItemInterface } from '../../entities/@blocks/Faq/Faq';
import { AsyncReduxState, initialAsyncReduxState } from '../defaults';

export type FaqState = AsyncReduxState<{
    faqItems: FaqItemInterface[];
    categories: FaqCategories;
}>;

const initialState: FaqState = {
    ...initialAsyncReduxState,
    faqItems: [],
    categories: {},
};

const faqSlice = createSlice({
    name: 'faqSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): FaqState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): FaqState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): FaqState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): FaqState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setFaqItems(state, action: PayloadAction<FaqItemInterface[]>): FaqState {
            return {
                ...state,
                faqItems: action.payload,
            };
        },
        setCategories(state, action: PayloadAction<FaqCategories>): FaqState {
            return {
                ...state,
                categories: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setFaqItems,
    setCategories,
} = faqSlice.actions;

export default faqSlice;
